import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const ForaIcon = ({
  color = 'foraBlue',
  width = 30,
  marginLeft,
  marginRight,
  containerSize,
  title = 'Fora',
}: DefaultIconProps) => (
  <DefaultIconWrapper
    marginLeft={marginLeft}
    marginRight={marginRight}
    containerSize={containerSize}
    title={title}
    width={width}
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
      <g fill={getSemanticTextColor(color)} fillRule="evenodd">
        <g>
          <path
            fill={getSemanticTextColor(color)}
            d="M23.435 14.316v1.086c-3.508 0-6.352 2.827-6.352 6.314H15.99c0-4.087 3.333-7.4 7.445-7.4zm0 2.563v1.086c-2.084 0-3.773 1.68-3.773 3.75h-1.093c0-2.67 2.178-4.836 4.866-4.836zM17.023 8c0 1.328-.263 2.594-.738 3.753h7.15v1.086c-4.932 0-8.93 3.975-8.93 8.877h-1.093c0-1.328.263-2.594.737-3.752H7.001v-1.087c4.931 0 8.93-3.975 8.93-8.877zm-1.343 7.404h-1.974c-.648.58-1.373 1.075-2.157 1.473h3.124c.292-.521.629-1.015 1.007-1.473zM14.445 8c0 4.087-3.333 7.4-7.445 7.4v-1.086c3.508 0 6.352-2.827 6.352-6.314zm4.44 4.839h-3.123c-.294.523-.632 1.018-1.012 1.478h1.973c.649-.582 1.376-1.08 2.162-1.478zM11.866 8c0 2.671-2.178 4.837-4.866 4.837v-1.086c2.084 0 3.774-1.68 3.774-3.75z"
          />
        </g>
      </g>
    </svg>
  </DefaultIconWrapper>
);
